// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__VipZr","colMaxWidth":"Table_colMaxWidth__1YK1a"};